import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_report_subscription_editor___ds_report_subscription_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { schedule_name?: string, module_id?: string, report_id?: string }): Promise<{ result?: { name?: string, is_enabled?: boolean, is_include_attachments?: boolean, to?: string, cc?: string, bcc?: string, subject?: string, body?: string, report?: { module_id?: string, report_id?: string, parameters?: string, parameter_definitions?: { id?: string, is_required?: boolean }[], report_title?: string, file_type?: string }, schedule?: string } }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      schedule_name?: string, module_id?: string, report_id?: string    }) {
      return false;
    }
}
